import { AppOptions } from "../../types/ui";
import { apiClient } from "./api-client";

export const uiApi = {
    getUI: () => apiClient.get<AppOptions>("/ui"),
}